import { render } from "./AliCaptcha.vue?vue&type=template&id=4d68a0b7&scoped=true&ts=true"
import script from "./AliCaptcha.vue?vue&type=script&lang=ts"
export * from "./AliCaptcha.vue?vue&type=script&lang=ts"

import "./AliCaptcha.vue?vue&type=style&index=0&id=4d68a0b7&scoped=true&lang=css"

import exportComponent from "/Users/zhangzhiyuan/vue_project/public-demo-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d68a0b7"]])

export default __exports__